import Button from "@components/_Layout/Controls/Button";
import MyFavorites from "../MyFavorites";
import PropTypes from "prop-types";
import React from "react";
import SideOverlay from "@components/_Layout/SideOverlay";
import { clearFavoritesEtabs, clearFavoritesProposals } from "@utils/favorites";
import { useSession } from "@hooks";
import { FavoriteBorderOutlined } from "@mui/icons-material";

type FavoritesOverlayProps = {
  //
};

const languagesVarsCodes = [
  "LANG_neobooking_delete_all_favorites_stays", //Supprimer tous mes séjours favoris
  "LANG_neobooking_delete_all_favorites_etabs", //Supprimer tous mes établissements favoris
  "LANG_neobooking_my_favorites", //Mes favoris
];

const FavoritesOverlay: React.FC<FavoritesOverlayProps> = () => {
  /* Hooks */
  const {
    sessionId,
    favoriteProposals,
    setFavoriteProposals,
    favoriteEtabs,
    setFavoriteEtabs,
    getLanguageVarValue,
  } = useSession();

  const handleClearFavoriteProposals = () => {
    clearFavoritesProposals(sessionId!!, (keys) => {
      setFavoriteProposals(keys);
    });
  };

  const handleClearFavoriteEtabs = () => {
    clearFavoritesEtabs(sessionId!!, (keys) => {
      setFavoriteEtabs(keys);
    });
  };

  return (
    <SideOverlay
      title={getLanguageVarValue("LANG_neobooking_my_favorites")}
      btnElement={(onClick) => (
        <button onClick={onClick} className="focus:tw-outline-none">
          <div className="tw-h-6 tw-relative tw-ml-2">
            <span className="tw-sr-only">Open favorites menu</span>
            <FavoriteBorderOutlined className="tw-block" fontSize="medium" />
            {(favoriteProposals.length > 0 || favoriteEtabs.length > 0) && (
              <span className="tw-bg-red-500 tw-w-2 tw-h-2 tw-rounded-full tw-absolute tw--right-1 tw-top-0"></span>
            )}
          </div>
        </button>
      )}
      children2={
        favoriteProposals.length > 0 || favoriteEtabs.length > 0 ? (
          <div className="tw-flex tw-gap-2">
            {favoriteProposals.length > 0 && (
              <Button
                onClick={handleClearFavoriteProposals}
                additionalClassname="tw-w-full"
                style={{ lineHeight: "1.15rem" }}
                type={"button"}
              >
                {getLanguageVarValue(
                  "LANG_neobooking_delete_all_favorites_stays"
                )}
              </Button>
            )}
            {favoriteEtabs.length > 0 && (
              <Button
                onClick={handleClearFavoriteEtabs}
                additionalClassname="tw-w-full"
                style={{ lineHeight: "1.15rem" }}
                type={"button"}
              >
                {getLanguageVarValue(
                  "LANG_neobooking_delete_all_favorites_etabs"
                )}
              </Button>
            )}
          </div>
        ) : undefined
      }
    >
      <MyFavorites />
    </SideOverlay>
  );
};

FavoritesOverlay.propTypes = {
  //
};

export default FavoritesOverlay;
